import React from 'react';
import { RichUtils } from 'draft-js';
import './Toolbar.css';

function preventDefault(e) {
  e.preventDefault();
}

class Toolbar extends React.Component {
  constructor(props) {
    super(props);

    this.toggleInlineStyle = this.toggleInlineStyle.bind(this);
    this.toggleBlockType = this.toggleBlockType.bind(this);
  }

  toggleInlineStyle (event) {
    event.preventDefault();
    let style = event.currentTarget.getAttribute('data-style');
    this.props.toggleInlineStyle(style);
  }

  toggleBlockType (event) {
    event.preventDefault();
    let block = event.currentTarget.getAttribute('data-block');
    this.props.toggleBlockType(block);
  }

  renderBlockButton(value, block) {
    const currentBlockType = RichUtils.getCurrentBlockType(this.props.editorState);
    let className = '';
    if (currentBlockType === block) {
      className = 'active';
    }

    return (
      <input
        type="button"
        key={block}
        value={value}
        className={className}
        data-block={block}
        onClick={this.toggleBlockType}
        onMouseDown={preventDefault}
      />
    );
  }

  renderInlineStyleButton(value, style) {
    const currentInlineStyle = this.props.editorState.getCurrentInlineStyle();
    let className = '';
    if (currentInlineStyle.has(style)) {
      className = 'active';
    }

    return (
      <input
        type="button"
        key={style}
        value={value}
        className={className}
        data-style={style}
        onClick={this.toggleInlineStyle}
        onMouseDown={preventDefault}
      />
    );
  }

  render() {
    const inlineStyleButtons = [
      {
        value: 'Bold',
        style: 'BOLD'
      },

      {
        value: 'Italic',
        style: 'ITALIC'
      },

      {
        value: 'Underline',
        style: 'UNDERLINE'
      },

      {
        value: 'Strikethrough',
        style: 'STRIKETHROUGH'
      },

      {
        value: 'Code',
        style: 'CODE'
      },

      {
        value: 'Highlight',
        style: 'HIGHLIGHT'
      }
    ];

    const blockTypeButtons = [
      {
        value: 'Heading One',
        block: 'header-one'
      },

      {
        value: 'Heading Two',
        block: 'header-two'
      },

      {
        value: 'Heading Three',
        block: 'header-three'
      },

      {
        value: 'Blockquote',
        block: 'blockquote'
      },

      {
        value: 'Unordered List',
        block: 'unordered-list-item'
      },

      {
        value: 'Ordered List',
        block: 'ordered-list-item'
      }
    ];

    return (
      <div className="toolbar">
        <div className="inline-style-options">
          <h2 className="toolbar-title">Inline styles:</h2>
          {inlineStyleButtons.map((button) => {
            return this.renderInlineStyleButton(button.value, button.style);
          })}
        </div>

        <div className="block-style-options">
        <h2 className="toolbar-title">Block types:</h2>
          {blockTypeButtons.map((button) => {
            return this.renderBlockButton(button.value, button.block);
          })}
        </div>
      </div>
    );
  }
}

export default Toolbar;
